import { render, staticRenderFns } from "./order-pane1.vue?vue&type=template&id=6dbc09bc&scoped=true"
import script from "./order-pane1.vue?vue&type=script&lang=ts"
export * from "./order-pane1.vue?vue&type=script&lang=ts"
import style0 from "./order-pane1.vue?vue&type=style&index=0&id=6dbc09bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc09bc",
  null
  
)

export default component.exports